import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** arrow pointing left, back. Decorative line icon; always pair with a visible text label. */
export function BackIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M19 12H5" />
      <path d="M11 6l-6 6 6 6" />
    </IconSvg>
  )
}
